/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const LocationFill: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      d='M12 3C14.1217 3 16.1569 3.8445 17.6572 5.34766C19.1574 6.85079 20 8.88994 20 11.0156C19.9998 15.8661 15.1564 20.0424 13.0068 21.6572C12.3991 22.1138 11.6009 22.1138 10.9932 21.6572C8.84361 20.0424 4.00024 15.8661 4 11.0156C4 8.88994 4.84261 6.85079 6.34277 5.34766C7.84306 3.8445 9.87827 3 12 3ZM12 8.5C10.6193 8.50003 9.50003 9.61934 9.5 11C9.5 12.3807 10.6193 13.5 12 13.5C13.3807 13.5 14.5 12.3807 14.5 11C14.5 9.61932 13.3807 8.5 12 8.5Z'
      fill='currentColor'
    />
  </React.Fragment>
)
